import React from 'react';

import {
  Hero,
  Industries,
  Models,
  GetInTouch,
  CompanyBadges,
} from './components';

export const Home = () => (
  <>
    <Hero />
    <Models />
    <Industries />
    <GetInTouch />
    <CompanyBadges />
  </>
);

export default Home;
